export default (theme) => ({
  font: {
    fontFamily: "quiroh, sans-serif",
    color: theme.palette.type === "dark" ? "white" : "black",
  },
});
